import { adminService } from "@/helpers/adminservice/admin.service";

const cache = {};

export function clearPlanAccessCache(solutionKey = null) {
  if (solutionKey) {
    delete cache[solutionKey];
    return;
  }

  Object.keys(cache).forEach((key) => delete cache[key]);
}

export async function subscriptionForSolution(solutionKey) {
  if (!solutionKey) {
    return null;
  }

  if (!cache[solutionKey]) {
    cache[solutionKey] = adminService
      .getSubscription({ solutionKey })
      .then((data) => (data ? data.subscription : null))
      .catch(() => null);
  }

  return cache[solutionKey];
}

export async function capabilitiesForSolution(solutionKey) {
  const subscription = await subscriptionForSolution(solutionKey);
  return subscription ? subscription.capabilities || {} : {};
}

export async function userHasCapability(solutionKey, capability) {
  if (!capability) {
    return true;
  }

  const capabilities = await capabilitiesForSolution(solutionKey);
  return capabilities[capability] === true;
}
